<template>

<app-table-cell class="badge" :class="{'is-empty': !application, 'has-icon': showIcon}" :border="border">

	<div class="badge-box" v-on:click.stop="onLinkClick" v-tooltip="(application) ? 'Click view application' : false">

        <template v-if="application">

            <app-icon icon="cell.application" class="badge-box-icon" v-if="showIcon" />

            <div class="badge-box-info">
                <div class="badge-box-name">{{ application.name }}</div>
                <div class="badge-box-reference">{{ application.reference }}</div>
            </div>

            <app-icon icon="open" class="badge-box-link" />

        </template>

        <template v-if="!application">

            <div class="badge-box-empty">{{ emptyText || 'No badge.' }}</div>

        </template>

    </div>

</app-table-cell>

</template>

<script>

export default {

	props: ['application', 'border', 'emptyText', 'showIcon'],

    methods: {
    
        onLinkClick: function() {
        
            if (this.application) this.$router.push({
                name: 'Convention.Registration.Applications.Edit',
                params: {
                    id: this.application.id
                }
            })
        
        }
    
    }

}

</script>

<style scoped>

.badge {
    padding: 7px 0px;
}

.badge-box {
    width: 100%;
    height: 40px;
    border: 1px solid #eee;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.75);
	cursor: pointer;
    padding: 0px 10px;
    display: grid;
    align-items: center;
    grid-template-columns: auto 32px;
}

.badge.has-icon .badge-box {
    grid-template-columns: 26px auto 32px;
}

.badge.is-empty .badge-box {
    pointer-events: none;
    border: 0px;
    background-color: transparent;
}

.row:hover .badge-box {
    border-color: transparent;
}

.badge-box:hover {
    background-color: #fff;
    border-color: #fff;
}

.badge-box-empty {
    color: #999;
}

.badge-box-icon {
    text-align: left;
	color: #4082d3;
}

.badge-box-name {
    font-size: 14px;
    line-height: 14px;
    color: #4082d3;
    font-weight: 500;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 40px);
}

.badge-box-reference {
    font-size: 12px;
    line-height: 12px;
    margin-top: 2px;
    color: #687589;
    font-weight: 300;
}

.badge-box-link {
    text-align: right;
	color: #4082d3;
}

</style>
